import React from "react";

const FeaturesSection = () => {
  const features = [
    {
      title: "Kolay Halısaha Kiralama",
      description:
        "Kullanıcı dostu arayüzümüzle sadece birkaç tıklamayla sahanızı kiralayın.",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    },
    {
      title: "Takım Arkadaşı Bul",
      description:
        "Eksik oyuncularınızı tamamlamak için takım arkadaşları bulun.",
      icon: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    },
    {
      title: "7/24 Erişim",
      description: "İstediğiniz sahayı istediğiniz zaman kiralayın.",
      icon: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z",
    },
    {
      title: "Doğrulanmış Değerlendirmeler",
      description: "Gerçek kullanıcı yorumlarıyla bilinçli kararlar verin.",
      icon: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
    },
    {
      title: "Lokasyon Arama",
      description:
        "Akıllı konum tabanlı aramayla yakınınızdaki sahaları bulun.",
      icon: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
    },
  ];

  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <header className="text-center mb-12">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Neden halisahabul?
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Modern ve kullanıcı odaklı özelliklerimizle halısaha kiralama
          deneyiminizi yeniden tanımlıyoruz.
        </p>
      </header>

      <div className="space-y-8">
        {features.map((feature, index) => (
          <article
            key={index}
            className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#4d9041] transform hover:-translate-y-1"
          >
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#4d9041] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                <svg
                  className="w-7 h-7 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d={feature.icon} />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-[#4d9041] transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#4d9041]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
          </article>
        ))}
      </div>

      {/* SEO Structured Data for Google */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: features.map((feature) => ({
            "@type": "Question",
            name: feature.title,
            acceptedAnswer: {
              "@type": "Answer",
              text: feature.description,
            },
          })),
        })}
      </script>
    </section>
  );
};

export default FeaturesSection;
